<template>

</template>
<script>
  // 1.创建阶段
  // beforeCreate(组件实例刚刚被创建，无法访问数据和事件) 
  //  created（已经创建完成，可以访问到data，和mounted方法体，但DOM尚未挂载）
  // 2. 挂载阶段
  //  beforeMount（挂载开始之前调用，相关的 render 函数首次被调用。此时 DOM 还没有生成。）
  //  mounted（在组件挂载到 DOM 上之后立即调用。可以在这里执行需要依赖 DOM 的操作，比如请求数据、初始化第三方库等。）
  // 3. 更新阶段
  //  beforeUpdate（当组件的响应式数据发生变化，DOM 重新渲染之前调用。此时你可以访问到旧的 data 和 DOM，但新的渲染结果还没有反映在视图上。）
  //  updated（当组件的响应式数据变化并且视图更新完成后调用。你可以在这里进行基于视图更新后的操作，但请避免在这个钩子中更改数据，因为这会导致无限更新循环。）
  // 4. 销毁阶段 
  //  beforeDestroy(组件销毁之前调用。此时，你可以进行清理操作，如销毁定时器、取消事件监听等。)
  // destroyed(组件销毁后调用。此时，组件的 DOM 和数据都已经被销毁，无法再访问组件实例的任何部分。)


  //监听message数据变化
  // watch:{}
  // 示例
  // 1.
  // data(){
  //     return{
  //         aaa:"aaa"
  //     }
  // }
  //     watch:{
  //         aaa(newValue, oldValue) {
  //   console.log(`message 改变了：`, oldValue, '->', newValue);
  // }
  //     }
  export default {
    data() {
      return {

      }
    },
    mounted() {

    },
    // 方法体
    methods: {

    },

  }
</script>
<style scoped>
  /* 针对电脑端 */
  @media screen and (min-width: 1024px) {}

  /* 针对手机端 */
  @media screen and (max-width: 1023px) {}
</style>
<!-- mounted() {
    this.executeMethods();
  },
  methods: {
    async executeMethods() {
      await this.method1();
      await this.method2();
      await this.method3();
    },
    async method1() {
      console.log('Method 1 executed');
      // 模拟异步操作
      return new Promise(resolve => setTimeout(resolve, 1000));
    },
    async method2() {
      console.log('Method 2 executed');
      // 模拟异步操作
      return new Promise(resolve => setTimeout(resolve, 1000));
    },
    async method3() {
      console.log('Method 3 executed');
      // 模拟异步操作
      return new Promise(resolve => setTimeout(resolve, 1000));
    }
  } -->
<!-- <template>

</template>
<script>
export default {
    data() {
      return {

      }
    },
    mounted() {

    },
    // 方法体
    methods: {

    },

  }</script>
  <style scoped>
  @media screen and (min-width: 1024px) {}

  @media screen and (max-width: 1023px) {}
</style> -->